import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { environment } from '../../../../environments/environment';
import { AutoPayRequest, AutoPayResponse } from '../models/accounts-notifications.model';

@Injectable({
  providedIn: 'root',
})
export class AccountsNotificationsService {
  constructor(private readonly httpClient: HttpClient, private readonly cookieService: CookieService) {}

  getAutoPayResponse(request: AutoPayRequest) {
    return this.httpClient.post<AutoPayResponse[]>(
      `${environment.cswEpayService}/${request.customerId}/autopayments/notifications`,
      request.accounts,
      {
        headers: new HttpHeaders().set('Authorization', this.cookieService.get('X-Access-Token')),
      }
    );
  }
}
